/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';

export interface PackageClaim {
    id?: number;
    packageId: number;
    claimantCourierId: number;
    claimantUserId: number;
    warehouseCourierId: number;
    status?: string;
    invoiceFile?: string[];
    notes?: string;
    recipientUserId?: number;
    recipientName?: string;
    reviewNotes?: string;
    reviewedBy?: number;
    reviewedAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    // Relation includes
    package?: any;
    claimantCourier?: any;
    warehouseCourier?: any;
    claimant?: any;
    reviewer?: any;
}

export function instanceOfPackageClaim(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "packageId" in value;
    isInstance = isInstance && "claimantCourierId" in value;
    isInstance = isInstance && "claimantUserId" in value;
    isInstance = isInstance && "warehouseCourierId" in value;
    return isInstance;
}

export function PackageClaimFromJSON(json: any): PackageClaim {
    return PackageClaimFromJSONTyped(json, false);
}

export function PackageClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageClaim {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'packageId': json['packageId'],
        'claimantCourierId': json['claimantCourierId'],
        'claimantUserId': json['claimantUserId'],
        'warehouseCourierId': json['warehouseCourierId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'invoiceFile': !exists(json, 'invoiceFile') ? undefined : json['invoiceFile'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'recipientUserId': !exists(json, 'recipientUserId') ? undefined : json['recipientUserId'],
        'recipientName': !exists(json, 'recipientName') ? undefined : json['recipientName'],
        'reviewNotes': !exists(json, 'reviewNotes') ? undefined : json['reviewNotes'],
        'reviewedBy': !exists(json, 'reviewedBy') ? undefined : json['reviewedBy'],
        'reviewedAt': !exists(json, 'reviewedAt') ? undefined : (json['reviewedAt'] === null ? undefined : new Date(json['reviewedAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (json['createdAt'] === null ? undefined : new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? undefined : new Date(json['updatedAt'])),
        'package': !exists(json, 'package') ? undefined : json['package'],
        'claimantCourier': !exists(json, 'claimantCourier') ? undefined : json['claimantCourier'],
        'warehouseCourier': !exists(json, 'warehouseCourier') ? undefined : json['warehouseCourier'],
        'claimant': !exists(json, 'claimant') ? undefined : json['claimant'],
        'reviewer': !exists(json, 'reviewer') ? undefined : json['reviewer'],
    };
}

export function PackageClaimToJSON(value?: PackageClaim | null): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'id': value.id,
        'packageId': value.packageId,
        'claimantCourierId': value.claimantCourierId,
        'claimantUserId': value.claimantUserId,
        'warehouseCourierId': value.warehouseCourierId,
        'status': value.status,
        'invoiceFile': value.invoiceFile,
        'notes': value.notes,
        'recipientUserId': value.recipientUserId,
        'recipientName': value.recipientName,
        'reviewNotes': value.reviewNotes,
        'reviewedBy': value.reviewedBy,
        'reviewedAt': value.reviewedAt === undefined ? undefined : (value.reviewedAt === null ? null : value.reviewedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
    };
}
